// src/components/ChatsManager.jsx
import { useChat } from "./useChats";
import ChatSidebar from "./components/ChatSidebar";
import ChatWindow from "./components/ChatWindow";

export default function ChatManager({ pendingLeadId, onPendingLeadHandled }) {
  const { chats, activeChat, messages, selectChat, sendMessage, sendTemplateMessage } =
    useChat({ pendingLeadId, onPendingLeadHandled });;

  return (
    <div style={styles.wrapper}>
      <ChatSidebar
        chats={chats}
        activeChat={activeChat}
        onSelectChat={selectChat}
      />
      <ChatWindow
        chat={activeChat}
        messages={messages}
        onSend={sendMessage}
        onSendTemplate={sendTemplateMessage}
      />
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    height: "100%",         // fills parent fixed box (top:64 → bottom:0) minus padding:16
    width: "100%",
    borderRadius: 10,
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    background: "#000000ff",
    boxShadow: "0 1px 8px rgba(0,0,0,0.07)",
  },
};